import React, { useEffect, useState } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase-config';

/**
 * Shows aggregate tenant + owner star ratings for a professional (from ProfessionalsData),
 * updated by Cloud Function when reviews are submitted.
 */
export default function ProfessionalRatingsHint({ professionalId, businessName }) {
  const [line, setLine] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!professionalId) {
      setLine(null);
      return;
    }
    let cancelled = false;
    setLoading(true);
    getDoc(doc(db, 'ProfessionalsData', professionalId))
      .then((snap) => {
        if (cancelled) return;
        if (!snap.exists()) {
          setLine('No ratings yet for this professional.');
          return;
        }
        const d = snap.data() || {};
        const tC = Number(d.tenantRatingCount) || 0;
        const tS = Number(d.tenantRatingSum) || 0;
        const oC = Number(d.ownerRatingCount) || 0;
        const oS = Number(d.ownerRatingSum) || 0;
        const parts = [];
        if (tC > 0) {
          parts.push(`Tenants: ★${(tS / tC).toFixed(1)} (${tC} review${tC === 1 ? '' : 's'})`);
        }
        if (oC > 0) {
          parts.push(`Owners: ★${(oS / oC).toFixed(1)} (${oC} review${oC === 1 ? '' : 's'})`);
        }
        const totalC = tC + oC;
        const totalS = tS + oS;
        if (totalC === 0) {
          setLine('No ratings yet for this professional.');
          return;
        }
        const combined = `Overall: ★${(totalS / totalC).toFixed(1)} from ${totalC} review${totalC === 1 ? '' : 's'}`;
        setLine(
          `${businessName ? `${businessName} — ` : ''}${combined}${parts.length ? ` · ${parts.join(' · ')}` : ''}`
        );
      })
      .catch(() => {
        if (!cancelled) setLine('Could not load ratings.');
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [professionalId, businessName]);

  if (!professionalId) return null;

  return (
    <div
      style={{
        marginBottom: 12,
        padding: '12px 14px',
        background: '#eff6ff',
        borderRadius: 8,
        border: '1px solid #bfdbfe',
        fontSize: 13,
        color: '#1e40af',
        lineHeight: 1.45,
      }}
    >
      <strong style={{ display: 'block', marginBottom: 4, color: '#1d4ed8' }}>Professional ratings</strong>
      {loading ? 'Loading…' : line}
    </div>
  );
}
